import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actions, Control } from 'react-redux-form'

import Dropdown from '../../utils/Dropdown'

import RequestFormStepButtons from './stepButtons'
import SemanticCheckbox from '../../inputs/checkbox'
import SemanticInput from '../../semanticInput'
import SiteType from './SiteType'
import SitesSelector from './SitesSelector/Index'
import Label from '../../utils/Label'

const electricOptions = [
  {
    label: 'No preference',
    value: ''
  },
  {
    label: '15 amps or more',
    value: '15'
  },
  {
    label: '20 amps or more',
    value: '20'
  },
  {
    label: '30 amps or more',
    value: '30'
  },
  {
    label: '50 amp service',
    value: '50'
  }
]

export const RequestFormStep3 = () => {
  const type = useSelector(store => store.availabilityRequestForm.type)
  const electric = useSelector(store => store.availabilityRequestForm.electric)
  const matchingSiteCount = useSelector(store => store.availabilityRequestForm.matchingSiteCount)
  const facility = useSelector(store => store.availabilityRequestForm.facility)

  const dispatch = useDispatch()

  const handleElectricClick = data => {
    dispatch(actions.change('availabilityRequestForm.electric', data.value))
  }

  const typeDetail = useCallback(
    detailName => {
      if (facility.sites_details?.types_details === undefined) {
        return facility.sites_details[detailName]
      }

      if (type === 'rv_tent') {
        return (
          facility.sites_details?.types_details?.rv[detailName] ||
          facility.sites_details?.types_details?.tent[detailName]
        )
      }

      return facility.sites_details?.types_details[type][detailName]
    },
    [type, facility]
  )

  return (
    <div className="mt-1 mb-4">
      <Label>Site Type</Label>
      <SiteType />

      {facility.sites_details && (
        <div className="mt-12 mb-12 grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
          {typeDetail('max_length') > 0 && (
            <div>
              <Label small>Min Site Length</Label>
              <Control model=".length" component={SemanticInput} />
            </div>
          )}
          {typeDetail('electric') && (
            <div>
              <Label small>Electric</Label>
              <div>
                <Dropdown options={electricOptions} onChange={handleElectricClick} value={electric} />
              </div>
            </div>
          )}
          {typeDetail('water') && (
            <div>
              <Control.checkbox
                model=".water"
                component={SemanticCheckbox}
                controlProps={{
                  label: 'Water'
                }}
              />
            </div>
          )}
          {typeDetail('sewer') && (
            <div>
              <Control.checkbox
                model=".sewer"
                component={SemanticCheckbox}
                controlProps={{
                  label: 'Sewer'
                }}
              />
            </div>
          )}
          {typeDetail('pullthru') && (
            <div>
              <Control.checkbox
                model=".pullthru;"
                component={SemanticCheckbox}
                controlProps={{
                  label: 'PullThru'
                }}
              />
            </div>
          )}
          {typeDetail('premium') && (
            <div>
              <Control.checkbox
                model=".sitePremium"
                component={SemanticCheckbox}
                controlProps={{
                  label: 'Only Premium Sites'
                }}
              />
            </div>
          )}
          {typeDetail('ada') && (
            <div>
              <Control.checkbox
                model=".ignoreAda"
                component={SemanticCheckbox}
                controlProps={{
                  label: "Don't include ADA Sites"
                }}
              />
            </div>
          )}
          {typeDetail('pets_allowed') && (
            <div>
              <Control.checkbox
                model=".petsAllowed"
                component={SemanticCheckbox}
                controlProps={{
                  label: 'Pets Allowed'
                }}
              />
            </div>
          )}
        </div>
      )}
      <SitesSelector />

      <div className="flex flex-wrap w-full mb-12 mt-12">
        <div className="flex-auto self-center">
          <RequestFormStepButtons disabled={matchingSiteCount === 0} />
        </div>
      </div>
    </div>
  )
}

export default RequestFormStep3
